module.exports = __webpack_public_path__ + "first-20-front.jpg?cd6f4e963f290a2f6ab4a22e8e637add";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20-front.jpg
// module id = 455
// module chunks = 0